import { PropertyValueType } from './Interfaces';

export type Json = Record<string, unknown>;

export const JsonType: PropertyValueType<Json> = Object.freeze({
    name: 'Json',
    fromString(value: string): [boolean, Json] {
        try {
            if (!!value) {
                return [true, JSON.parse(value)];
            }
        }
        catch { }
        return [false, null];
    },
    serialize(value: Json): any {
        return JSON.stringify(value);
    },
    deserialize(value: any, defau1t?: Json): Json {
        if (typeof value === 'string') {
            const [ok, val] = JsonType.fromString(value);
            if (ok) return val;
        }
        return defau1t ?? null;
    },
});
